import { getValidationResolver, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';
import { REQUIRED_TEXT } from '@/common/constants';

export enum ProviderFormField {
  providerName = 'providerName',
  addressLine1 = 'addressLine1',
  addressLine2 = 'addressLine2',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
}

export interface ProviderForm {
  [ProviderFormField.providerName]: string;
  [ProviderFormField.addressLine1]: string;
  [ProviderFormField.addressLine2]: string;
  [ProviderFormField.city]: string;
  [ProviderFormField.state]: string;
  [ProviderFormField.zipCode]: string;
}

interface Props {
  isViewMode?: boolean;
  defaultValues?: Partial<ProviderForm>;
}

const useProviderForm = ({ isViewMode = false, defaultValues }: Props = {}) => {
  const validationSchema = isViewMode ? {} : {
    [ProviderFormField.providerName]: VALIDATORS.REQUIRED_STRING,
    [ProviderFormField.addressLine1]: VALIDATORS.REQUIRED_STRING,
    [ProviderFormField.addressLine2]: VALIDATORS.STRING,
    [ProviderFormField.city]: VALIDATORS.CITY,
    [ProviderFormField.state]: VALIDATORS.REQUIRED_STRING,
    [ProviderFormField.zipCode]: VALIDATORS.ZIP_CODE.required(REQUIRED_TEXT),
  };

  const methods = useForm<ProviderForm>({
    resolver: getValidationResolver(validationSchema),
    defaultValues,
  });

  return { methods };
};

export default useProviderForm;
